import * as TYPES_EVENT from './event.types';

const INITIAL_STATE = {
  detail: {
    payload: null,
    loading: true,
    error: null,
  },
  ticket: {
    payload: null,
    loading: true,
    error: null,
  },
  categories: {
    payload: null,
    loading: false,
    loaded: false,
    error: null,
  },
  eventsList: {
    payload: null,
    loading: false,
    loaded: false,
    error: null,
  },
};

const eventReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Event Detail actions
    case TYPES_EVENT.GET_EVENT_DETAIL_LOADING:
      return {
        ...state,
        detail: { ...state.detail, loading: true, error: null, payload: null },
      };
    case TYPES_EVENT.GET_EVENT_DETAIL_DATA:
      return {
        ...state,
        detail: {
          payload: action.payload,
          loading: false,
          error: null,
        },
      };
    case TYPES_EVENT.GET_EVENT_DETAIL_ERROR:
      console.log('Reducer GET_EVENT_DETAIL_ERROR:', action.error);
      return {
        ...state,
        detail: {
          ...state.detail,
          payload: null,
          loading: false,
          error: action.error,
        },
      };

    case TYPES_EVENT.GET_EVENTS_LIST_LOADING:
      return {
        ...state,
        eventsList: {
          ...state.eventsList,
          loading: action.loading,
          error: null,
        },
      };
    case TYPES_EVENT.GET_EVENTS_LIST_DATA:
      return {
        ...state,
        eventsList: {
          payload: action.payload,
          loading: false,
          loaded: true,
          error: null,
        },
      };

    // Ticket actions
    case TYPES_EVENT.GET_TICKET_LOADING:
      return {
        ...state,
        ticket: { ...state.ticket, loading: action.loading, error: null },
      };
    case TYPES_EVENT.GET_TICKET_DATA:
      return {
        ...state,
        ticket: {
          payload: action.payload,
          loading: false,
          error: null,
        },
      };

    case TYPES_EVENT.GET_EVENT_CATEGORIES_LOADING:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: action.loading,
          error: null,
        },
      };
    case TYPES_EVENT.GET_EVENT_CATEGORIES_DATA:
      return {
        ...state,
        categories: {
          payload: action.payload,
          loading: false,
          loaded: true,
          error: null,
        },
      };

    default:
      return state;
  }
};

export default eventReducer;
